<script>
import Access from '@/utils/access';
import api from '@/api/project';
import companyApi from '@/api/company';

import modelUserCustomSettings from '@/model/userCustomSettings';
import userFavorites from '@/model/userFavorites';
import DefaultLayout from '@/layouts/Default.vue';
import CommonSection from '@/components/CommonSection.vue';
import PageSlug from '@/components/PageSlug.vue';
import projectModel from '@/model/project';
import BaseTabs2 from '@/components/BaseTabs2.vue';
import NotificationCount from '@/components/base/NotificationCount.vue';
import ProjectFiltersContainer from './project/ProjectFiltersContainer.vue';
import ProjectTile from './ProjectTile.vue';
import ProjectRow from './project/ProjectRow.vue';
import BaseBookmark from './BaseBookmark.vue';
import UserTile from './UserTile.vue';
import BaseTableProgressCell from './project/list/BaseTableProgressCell.vue';
import UsersTile from './UsersTile.vue';
import EllipsisMenu from './EllipsisMenu.vue';
import BaseTableProjectCell from './project/list/BaseTableProjectCell.vue';
import BaseTableHeaderItem from './base/BaseTableHeaderItem.vue';

export default {
  name: 'ProjectList2',
  components: {
    NotificationCount,
    ProjectTile,
    DefaultLayout,
    CommonSection,
    PageSlug,
    ProjectFiltersContainer,
    ProjectRow,
    EllipsisMenu,
    BaseTableProjectCell,
    BaseBookmark,
    UsersTile,
    UserTile,
    BaseTableProgressCell,
    BaseTableHeaderItem,
    BaseTabs2,
  },
  props: {
    archived: Boolean,
  },
  data() {
    return {
      items: [],
      companies: [],
      filters: {
        tab: 'active',
        projectName: '',
        authors: [],
        members: [],
        departments: [],
      },
      sorter: {
        value: null,
        direction: null,
      },
      order: false,
      isTileForced: false,
      isTablet: false,
      sort: null,
      areArchivedAlreadyFetched: false,
    };
  },
  created() {
    this.fetch();
    companyApi.fetchList({}, true).then(r => { this.companies = r.items });
  },
  mounted() {
    window.addEventListener('resize', this.checkResize);
    this.checkResize();
  },
  beforeDestroy() {
    document.removeEventListener('resize', this.checkResize);
  },
  computed: {
    currUser() { return this.$store.state.auth.user; },
    accountSettings() { return this.currUser?.customSettings?.settings ?? {}; },
    orientationType() { return this.accountSettings?.projectListOrientationType ?? 'square'; },
    notificationCount() { return this.$store.getters['notification/countByProject']; },
    tabs() {
      return [
        { name: 'active', label: 'Активные' },
        { name: 'my', label: 'Мои' },
        { name: 'fav', label: 'Избранные', icon: { name: 'bookmarks2', colored: true, style: { color: '#FFC531' } } },
        { name: 'template', label: 'Шаблоны' },
        { name: 'archived', label: 'Архивные' },
      ];
    },
    headers() {
      return [
        { title: '',                className: 'bookmark-cell'                            }, // eslint-disable-line
        { title: 'Проект',          className: 'project-cell',    sortFn: 'name'          }, // eslint-disable-line
        { title: 'Руководитель',    className: 'author-cell',     sortFn: 'authorName'    }, // eslint-disable-line
        { title: 'Сроки проекта',   className: 'date-cell',       sortFn: 'dateProgress'  }, // eslint-disable-line
        { title: 'Прогресс',        className: 'progress-cell',   sortFn: 'taskProgress'  }, // eslint-disable-line
        { title: '',                className: 'menu-cell'                                }, // eslint-disable-line
      ].map(header => ({ header, sort: (this.sort ?? {}).title === header.title, order: this.order === 'asc' }));
    },
    favorites() {
      return userFavorites.getFavorites('project');
    },
    title() {
      return this.archived ? 'Архивные проекты' : 'Проекты';
    },
    itemsFiltered() {
      return this.items
        .map((project) => {
          const authorName = (project.author.name || project.author.surname) ? (project.author.name + project.author.surname).toLowerCase() : project.author.email.toLowerCase();

          const membersIds = project.projectMembers.map((m) => m.user['@id']);
          // const currUserIri = this.$store.state.auth.user['@id'];
          // const isUserMemberOfProject = project.author['@id'] === currUserIri
          //   || membersIds.includes(currUserIri);

          const notificationCount = this.notificationCount[project.id] ?? 0;
          return {
            ...project,
            notificationCount,
            membersIds,
            // isUserMemberOfProject,
            isFavorite: userFavorites.isFavorite('project', project['@id']),
            taskProgress: (project.numberOfClosedTasks / project.numberOfTasks) * 100,
            timeProgress: this.getTimeProgress(project),
            authorName,
          };
        })
        .filter((p) => (
          ((p.name.toLowerCase().includes(this.filters.projectName.toLowerCase())) || p.name.toLowerCase() === '')
          && (this.filters.authors.includes(p.author['@id']) || !this.filters.authors.length)
          && (this.filters.departments.includes(p.companyDepartment?.['@id']) || !this.filters.departments.length)
          && (this.filters.members.find((member) => p.membersIds.includes(member)) || !this.filters.members.length)
          && (this.filters.tab === 'archived' || !p.isArchived)
          // && (this.filters.tab === 'template' || p.isUserMemberOfProject)
          && (
            (this.filters.tab === 'active' && !p.isDraft && !p.isTemplate)
            || (this.filters.tab === 'my' && p.author.id === this.$store.state.auth.user.id && !p.isTemplate)
            || (this.filters.tab === 'fav' && p.isFavorite)
            || (this.filters.tab === 'archived' && p.isArchived && !p.isTemplate)
            || (this.filters.tab === 'template' && p.isTemplate)
          )
        ));
    },
    itemsFilteredSorted() {
      const sortedItems = [...this.itemsFiltered];

      return (!this.sorter.value)
        ? sortedItems
          .sort((a, b) => new Date(b.dateStart).getTime() - new Date(a.dateStart).getTime())
          .sort((a, b) => b.notificationCount - a.notificationCount)
        : sortedItems.sort((a, b) => {
          const [aa, bb] = this.sorter.direction === 'asc' ? [a, b] : [b, a];

          if (this.sorter.value === 'dateStart') return new Date(aa.dateStart).getTime() - new Date(bb.dateStart).getTime();
          if (this.sorter.value === 'dateFinish') return new Date(aa.dateFinish).getTime() - new Date(bb.dateFinish).getTime();
          if (this.sorter.value === 'name') return aa.name.toLowerCase().localeCompare(bb.name.toLowerCase());
          if (this.sorter.value === 'taskProgress') return aa.taskProgress - bb.taskProgress;
          if (this.sorter.value === 'dateProgress') return aa.timeProgress - bb.timeProgress;
          if (this.sorter.value === 'authorName') return aa.authorName.localeCompare(bb.authorName);

          return 0;
        });
    },
  },
  watch: {
    'filters.tab'(val) {
      if (val !== 'archived') return;
      if (this.areArchivedAlreadyFetched) return;

      this.fetch(true);
      this.areArchivedAlreadyFetched = true;
    }
  },
  methods: {
    fetch(includeArchived) {
      const filter = includeArchived ? {} : { isArchived: false };
      api.fetchList(filter, true).then(r => {
      // api.fetchList({}, true).then(r => {
        this.items = r.items;

        if (this.$route.query.departments) {
          const projectDepartments = this.items
            .map(p => p.companyDepartment?.['@id'])
            .filter(p => p);
          // при переходе по router-link параметр приходит тем, чем его передали
          // (числом для одного отдела), строкой он становится только после
          // перезагрузки страницы — без приведения split падал
          const ids = String(this.$route.query.departments ?? '');
          const iris = ids.split(',').map(id => `/api/company_departments/${id}`);

          this.filters.departments = iris.filter(iri => projectDepartments.includes(iri));
        }
      });
    },
    saveOrientationType(val) {
      const settings = { ...this.accountSettings, projectListOrientationType: val };
      modelUserCustomSettings.set({ settings });
    },

    changeFilters(value, field) {
      this.filters[field] = value;
    },
    changeSorter(value) {
      if (!value) this.sorter = { value, direction: null };
      else {
        const splitter = value.split('_');
        this.sorter = { value: splitter[1], direction: splitter[0] };
      }
    },
    clearFilters() {
      this.filters.projectName = '';
      this.filters.members = [];
      this.filters.authors = [];
      this.sorter.value = null;
      this.sorter.direction = null;
    },
    checkResize() {
      this.isTileForced = window.innerWidth < 768;
    },
    sortBy(header) {
      this.sort = header;
      this.sorter.value = header.sortFn;

      if (this.sort === header) {
        this.order = (this.order === 'asc') ? 'desc' : 'asc';
        this.sorter.direction = this.order;
      } else {
        this.order = 'asc';
        this.sorter.direction = this.order;
      }
    },
    getElipsisMenuItems(project) {
      const access = new Access(project, this.$store.state.auth.user);

      const onRemoved = () => { this.items = this.items.filter((item) => item.id !== project.id); };
      const onArchiveStateChanged = () => {
        const p = this.items.find(i => i.id === project.id);
        if (!p) return;
        p.isArchived = !p.isArchived;
      };
      const onProjectLeft = () => { this.fetch(); };
      const onCompanyDepartmentUpdated = () => { this.fetch(); };


      return projectModel.getEllipsisMenu({
        access,
        project,
        onArchiveStateChanged,
        onRemoved,
        onProjectLeft,
        onCompanyDepartmentUpdated,
      });
    },
    getTimeProgress(project) {
      const dateFinish = (project.dateFinish) ? new Date(project.dateFinish).getTime() : 0;
      const dateStart = new Date(project.dateStart).getTime();
      const currentDate = new Date().getTime();

      if (dateFinish === 0) return 0;

      if (currentDate > dateFinish) {
        return 100;
      }

      return (currentDate / (dateFinish - dateStart)) * 100;
    },
    getNotificationCount(project) {
      const getter = this.$store.getters['notification/itemIdsByFilter'];
      return getter({ projectId: project.id }).length;
    },
  },

};
</script>

<template lang="pug">
  CommonSection(:title="title" :back="archived ? { name: 'project-list', title: 'Вернуться к активным проектам' } : null")
    template(#button)
      .header-buttons
        Btn(dark xl :to="{ name: 'project-create' }")
          Icon(name="plus")
          | Новый проект
    .projects-body
      .tabs
        BaseTabs2(:items="tabs" v-model="filters.tab")
      ProjectFiltersContainer.filters-container(
        :filters="filters"
        @changeFilters="changeFilters"
        :projects="items"
        :companies="companies"
        :clearSorter="sorter.value === null"
        :sorter="sorter"
        :orientationType="orientationType"
        @changeSorter="changeSorter"
        @changeOrientationType="saveOrientationType"
        @clearFilters="clearFilters")
      template(v-if="!itemsFilteredSorted.length")
        PageSlug(v-if="filters.tab === 'template'")
          div(style="max-width: 500px")
            div
              h2 Шаблон проекта можно создать на основе активного проекта. Для создания шаблона:
              br
              ol(style="font-size: 14px; font-weight: 400")
                li Перейдите на вкладку "Активные".
                li Cоздайте новый проект или выберите один из уже существующих проектов.
                li В выбранном проекте кликните <b>(...)</b>, в открывшемся меню выберите пункт "Создать шаблон". Обратите внимание, что файлы проекта <b>не будут</b> скопированы.
                li При необходимости шаблон проекта можно отредактировать, а так же загрузить файлы (инструкции, регламенты, договора, акты и т.д.). Файлы, загруженные в шаблон проекта, <b>будут</b> скопированы при создании нового проекта из шаблона.
            br
            br
            div
              p Для создания проекта из шаблона:
              br
              ol(style="font-size: 14px; font-weight: 400")
                li Перейдите на вкладку "Шаблоны".
                li В активном проекте кликните <b>(...)</b>, в открывшемся меню выберите пункт "Создать проект".
        PageSlug(v-else tooltipText="Начните работу <br> с создания проекта")
          Btn(green :to="{ name: 'project-create' }") Создать проект
      template(v-else)
        .projects-tiles(v-if="orientationType === 'square' || isTileForced")
          ProjectTile.project-tile(v-for="project in itemsFilteredSorted" :key="project['@id']" :project="project" :menuItems="getElipsisMenuItems(project)")
        .projects-table(v-else)
          .headers
            BaseTableHeaderItem(v-for="header in headers" :key="header.header.className" :class="[header.header.className]" v-bind="header" @sort="sortBy")
          .table-data
            .project-row(v-for="item in itemsFilteredSorted" :key="item.id" :class="{ archived: item.isArchived }")
              BaseBookmark.bookmark-cell(:category="'project'" :id="item['@id']")
              BaseTableProjectCell.project-cell(:project="item" :isAuthor="item.author.id === $store.state.auth.user.id")
              UserTile.author-cell(:user="item.author")
              BaseTableProgressCell.date-cell(:project="item" :type="'date'")
              BaseTableProgressCell.progress-cell(:project="item" :type="'task'")
              .menu-cell
                NotificationCount(:count="getNotificationCount(item)")
                EllipsisMenu(:items="getElipsisMenuItems(item)")
</template>

<style scoped lang="scss">
.filters-container {
  width: 100%;
}

.header-buttons {
  display: flex;
  gap: 36px;
}

.tabs {
  overflow-x: auto;
}

.projects-tiles {
  display: grid;
  gap: 36px;
  grid-template-columns: repeat(12, 1fr);
}

.projects-body {
  display: flex;
  flex-direction: column;
  gap: 40px;
  padding-bottom: 75px;
}

.projects-table {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 0;
}

.table-data {
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.headers {
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 0 32px;
}

.projects-container {
  width: 100%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: flex-start;
  gap: 15px;
}

.show-more-area {
  width: 100%;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 50px;
}

.button-show-more {
  height: 100%;
}

.project-row {
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding: 30px 32px;
  justify-content: space-between;
  width: 100%;
  background-color: #FFFFFF;
  border-radius: 8px;
  box-shadow: 0px 6px 20px 0px rgba(156, 156, 156, 0.08);
  &.archived {
    filter: grayscale(100%);
  }
}

.bookmark-cell {
  width: 2%;
}

.project-cell {
  width: 20%;

  @media (max-width: 1450px) {
    width: 18%;
  }

  @media (max-width: 1300px) {
    width: 20%;
  }

  @media (max-width: 1130px) {
    width: 25%;
  }

  @media (max-width: 806px) {
    width: 30%;
  }
}

.author-cell {
  width: 20%;

  @media (max-width: 1450px) {
    width: 13%;
  }

  @media (max-width: 1140px) {
    width: 19%;
  }
}

.date-cell {
  width: 16%;

  @media (max-width: 1450px) {
    width: 18%;
  }

  @media (max-width: 1300px) {
    width: 22%;
  }

  @media (max-width: 1140px) {
    width: 25%;
  }

  @media (max-width: 806px) {
    width: 22%;
  }
}

.progress-cell {
  width: 10%;

  @media (max-width: 1300px) {
   display: none;
  }
}

.members-cell {
  width: 15%;

  @media (max-width: 1300px) {
    width: 12%;
  }

  @media (max-width: 1600px) {
    width: 11%;
  }

  @media (max-width: 1250px) {
    width: 13%;
  }

  @media (max-width: 1140px) {
    display: none;
  }
}


.menu-cell {
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: flex-end;

  width: 4%;

  @media (max-width: 1249px) {
    width: 5%;
  }
}

@media (max-width: 1249px) {
  .projects-tiles {
    gap: 24px;
    grid-template-columns: repeat(8, 1fr);
  }
}

@media (max-width: 768px) {
  .projects-tiles {
    gap: 20px;
    grid-template-columns: repeat(4, 1fr);
  }
}

</style>
